export default {
  sections: {
    setup_fee: {
      title: 'Erstellungskosten',
      description: 'Erstellungskosten ab {{amount}} – statt 1.000+',
    },
  },
  labels: {
    month: 'Monat (netto)',
    one_time_fee: 'Einmalgebühr',
    more_options: 'Weitere Optionen',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Eigene App im App Store & Google Play',
    push_notifications: 'Push-Benachrichtigungen für Angebote',
    loyalty: 'Kundenbindung durch Loyalität-Programme',
    offline_orders: 'Offline-Bestellungen möglich',
    individual_design: 'Individuelles App-Design',
  },
  setup_fee_options: {
    150: 'Standard setup',
    75: 'Reduziert',
    0: 'Keine Erstellungskosten',
  },
  feedback: {
    contract_signed_already: {
      title: 'Der Vertrag ist bereits unterzeichnet.',
      description: 'Bitte wenden Sie sich an den technischen Support, wenn Sie die Änderungen vornehmen müssen.',
    },
  },
};
